/* av2kit.js — advertorial interactivity (no inline <script> anywhere on the page)
   - floating sticky CTA (French label) -> /products/airovine
   - every .av2 a / .av2 button -> /products/airovine (keeps mailto:/tel:)
   - reveals GemPages scroll-hidden content (static clone has no builder JS)
   - rebuilds any leftover carousel/tabs/accordion as native (FAQ is already native <details>)
   - re-runs on shopify:section:load so it also works inside the theme editor */
(function () {
  var PRODUCT = "/products/airovine";
  var STICKY_LABEL = "PROFITER DE -50 % MAINTENANT";

  function keepScheme(href) {
    return /^(mailto:|tel:|sms:)/i.test(href || "");
  }

  function wireLinks(root) {
    (root || document).querySelectorAll(".av2 a, .av2 button").forEach(function (el) {
      var href = el.getAttribute ? el.getAttribute("href") : null;
      if (keepScheme(href)) return;
      if (el.tagName === "A") {
        el.setAttribute("href", PRODUCT);
        el.removeAttribute("target");
      } else {
        if (el.__av2wired) return;
        el.__av2wired = true;
        el.addEventListener("click", function (e) { e.preventDefault(); window.location.href = PRODUCT; });
      }
      el.style.cursor = "pointer";
    });
  }

  function reveal(root) {
    var r = root || document;
    r.querySelectorAll(".gps-lazy").forEach(function (el) {
      el.classList.remove("gps-lazy"); el.style.opacity = "1";
    });
    r.querySelectorAll("[data-gp-reveal],.gp-reveal,[class*='gp-animate']").forEach(function (el) {
      el.style.opacity = "1"; el.style.transform = "none";
    });
  }

  /* Any residual builder carousel -> a plain swipeable scroll-row so every card shows. */
  function fixCarousels(root) {
    (root || document).querySelectorAll("[class*='gp-carousel'] .gp-content-start").forEach(function (track) {
      track.style.display = "flex";
      track.style.flexWrap = "nowrap";
      track.style.overflowX = "auto";
      track.style.transform = "none";
      track.style.height = "auto";
    });
  }

  /* Any residual accordion that isn't a native <details> -> make it toggle on click. */
  function fixAccordions(root) {
    (root || document).querySelectorAll(".accordion__content,.accordion__content-wrapper").forEach(function (el) {
      el.style.maxHeight = "none"; el.style.height = "auto"; el.style.overflow = "visible";
    });
  }

  function ensureSticky() {
    if (document.getElementById("av2-sticky-cta")) return;
    if (!document.querySelector(".av2")) return;
    var a = document.createElement("a");
    a.id = "av2-sticky-cta";
    a.href = PRODUCT;
    a.textContent = STICKY_LABEL;
    document.body.appendChild(a);
  }

  function run(root) {
    wireLinks(root);
    reveal(root);
    fixCarousels(root);
    fixAccordions(root);
    ensureSticky();
  }

  if (document.readyState !== "loading") run(document);
  else document.addEventListener("DOMContentLoaded", function () { run(document); });

  document.addEventListener("shopify:section:load", function (e) { run(e.target || document); });
})();
